<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" acceptLabel="Oui" rejectLabel="Non"></p-confirmDialog> 
<h3 class="text-center mt-0 m-b-15"> 
    <img src="/assets/images/logo4.png" height="60" alt="logo">
    Confirmer votre compte Coffre-fort numérique 
</h3>
<div class="row col-lg-12 col-md-12 col-sm-12 col-12">
  <div class="col-lg-2 col-md-2" id="div1">
    <img class="pic-login-2" src="/assets/images/pic-login-2.svg">
  </div>
  <div class="col-lg-10 col-md-10 col-sm-12 col-12 login-form">
    <div class="center-screen container-login100 bodybg-color"> 
        <p-card class="customCard">
          <p-header class="customHeader"> 
            <form action="#" novalidate>
              <span class="headerTitle" *ngIf="!isError && step == 1">
                <h3>Question secrète</h3>
              </span>
              <div *ngIf="step == 1">
                <div class="alert alert-danger" *ngIf="submitted && isError">
                  Une erreur est survenue lors du traitement de votre demande.
                </div>              
                <div class="row">
                  <div class="col-md-4 col-connect-action">
                    <button type="submit" class="btn btn-primary" (click)="save()">
                      <span class="btn-label">
                        <i class="pi pi-save"></i>
                      </span>Enregsitrer
                      <span *ngIf="isLoading" class="spinner-border spinner-border-sm" style="color:#B22222;"
                            role="status" aria-hidden="true"></span>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="step == 2">
                <div class="alert alert-info" *ngIf="submitted && !isError && isConfirmed" style="max-width:600px!important;">
                  Un lien vous a été envoyé sur votre adresse e-mail {{CryptedEmail}} afin de créer votre mot de passe Coffre-fort numérique. 
                  <button type="submit" class="btn btn-primary" (click)="redirectToLogin()">
                    <span class="btn-label">
                      <i class="pi pi-unlock"></i>
                    </span>Se connecter
                  </button>
                </div>
              </div>
            </form>
          </p-header>
        </p-card> 
    </div>
  </div>
</div>

